import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  PossibleNowRequest,
  REGISTRATION_CONFIG,
  RegistrationConfig,
} from '@us-registration/util-models';
import * as CryptoJS from 'crypto-js';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PossibleNowService {
  constructor(
    @Inject(REGISTRATION_CONFIG)
    protected readonly registrationConfig: RegistrationConfig,
    protected readonly httpClient: HttpClient
  ) {}

  generateHmac(payload: string, secretKey: string): string {
    const keyWordArray = CryptoJS.enc.Utf8.parse(secretKey);
    const sha256hash = CryptoJS.HmacSHA256(payload, keyWordArray);
    const base64Hash = CryptoJS.enc.Base64.stringify(sha256hash);
    return base64Hash;
  }

  generateAuthorizationHeader(): string {
    const dateTime = new Date().toISOString();
    const userName = 'wp_d_g_api';
    const stringToHash = `whirlpool:${userName}:${dateTime}`;
    const hash = this.generateHmac(
      stringToHash,
      this.registrationConfig.possibleNowSalt
    );
    const authenticationScheme = 'PNAUTHINFO3-HMAC-sha256';
    return `${authenticationScheme} Credential=${userName}/${dateTime} Signature=${hash}`;
  }

  sendToPossibleNow(
    possibleNowRequest: PossibleNowRequest[]
  ): Observable<void> {
    const headers = new HttpHeaders({
      Authorization: this.generateAuthorizationHeader(),
    });

    return this.httpClient.post<void>(
      `${this.registrationConfig.possibleNowApi}`,
      possibleNowRequest,
      { headers }
    );
  }
}
